/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/legacy/core.mobile';

import 'handsontable/dist/handsontable.full.min.css';
import 'resources/less/themes/base/widgets/mailing_lists.less';

import MailingListsWidget from 'assets/js/modules/widgets/mailingLists/mailingListsWidget';
import MailingListsWidgetModel from 'assets/js/modules/widgets/mailingLists/model/mailingListsWidgetModel';
import MailingListsWidgetView from 'assets/js/modules/widgets/mailingLists/view/mailingListsWidgetView';
import mailingListsApi from 'assets/js/modules/api/mailingLists';

$(function() {
    var settings = $('#mailing-list-model-settings');
    var cartItemId = settings.data('cart-item-id');
    var cartToken = settings.data('cart-token');
    var listTokenChosen = settings.data('list-token');
    var continuePath = settings.data('continue-path');
    var $continueBtn = $('#attach-mailing-list');

    ONP.user.email = settings.data('user-email');

    var model = new MailingListsWidgetModel({
        listTokenChosen: listTokenChosen,
        user: ONP.user,
        cartToken: cartToken,
        cartItemId: cartItemId
    });
    new MailingListsWidgetView({
        model: model,
        el: '#mailing-lists-widget'
    });

    var widget = new MailingListsWidget(model);
    widget.on('startLoading', function() {
        $continueBtn.prop('disabled', true);
    });
    widget.on('stopLoading', function() {
        $continueBtn.prop('disabled', false);
    });

    $('.cancel-editing').on('click', function() {
        window.history.back();
    });

    $continueBtn.on('click', function() {
        if (widget.getItemsCount() == 0) {
            alert('Your list contains no records.');
            return false;
        }

        if (widget.getCurrentListToken() == null && cartToken && cartItemId) {
            widget.save(function() {
                mailingListsApi
                    .attachListToCartItem(cartToken, cartItemId, widget.getCurrentListToken())
                    .on('success', function() {
                        window.location.href = getContinuePath();
                    })
                    .on('error', function() {
                        alert("Can't assign mailing list to cart item");
                    })
                    .on('complete', function() {
                        widget.stopLoading();
                    })
                    .start();
            });
        } else if (listTokenChosen != widget.getCurrentListToken() && cartToken && cartItemId) {
            mailingListsApi
                .attachListToCartItem(cartToken, cartItemId, widget.getCurrentListToken())
                .on('success', function() {
                    widget.save(function() {
                        window.location.href = getContinuePath();
                    });
                })
                .on('error', function() {
                    alert("Can't assign mailing list to cart item");
                })
                .on('complete', function() {
                    widget.stopLoading();
                })
                .start();
            widget.startLoading();
        } else {
            widget.save(function() {
                window.location.href = getContinuePath();
            });
        }

        function getContinuePath() {
            return continuePath + '&totalListCount=' + widget.getItemsCount() + '&selectedListToken=' + widget.getCurrentListToken();
        }
    });
});
